var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.9075C30.34 23.9075 30.67 23.9475 31 23.9975V20.4875C31 19.6875 30.53 18.9675 29.8 18.6575L24.3 16.2575C23.79 16.0375 23.21 16.0375 22.7 16.2575L17.2 18.6575C16.47 18.9775 16 19.6975 16 20.4875V24.0875C16 28.6275 19.2 32.8775 23.5 33.9075C24.05 33.7775 24.58 33.5875 25.1 33.3575C24.41 32.3775 24 31.1875 24 29.9075C24 26.5975 26.69 23.9075 30 23.9075Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.9075C27.79 25.9075 26 27.6975 26 29.9075C26 32.1175 27.79 33.9075 30 33.9075C32.21 33.9075 34 32.1175 34 29.9075C34 27.6975 32.21 25.9075 30 25.9075ZM30 27.2875C30.62 27.2875 31.12 27.7975 31.12 28.4075C31.12 29.0175 30.61 29.5275 30 29.5275C29.39 29.5275 28.88 29.0175 28.88 28.4075C28.88 27.7975 29.38 27.2875 30 27.2875ZM30 32.6575C29.07 32.6575 28.26 32.1975 27.76 31.4875C27.81 30.7675 29.27 30.4075 30 30.4075C30.73 30.4075 32.19 30.7675 32.24 31.4875C31.74 32.1975 30.93 32.6575 30 32.6575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalChannelIcon);
export default __webpack_public_path__ + "static/media/digital_channel_icon.8b74c7d5e53fd48a3f2761a82fdfe8f4.svg";
export { ForwardRef as ReactComponent };